import { Header } from './Header';
import { Footer } from './Footer';
import { Link } from 'react-router-dom';
import { Calculator, Send, Phone } from 'lucide-react';

const MobileActionBar = () => (
  <div className="border-b border-slate-200 bg-white px-3 py-2 shadow-sm lg:hidden">
    <div className="mx-auto grid max-w-md grid-cols-3 gap-2">
      <Link
        to="/pachtrechner"
        className="flex min-h-12 flex-col items-center justify-center gap-1 rounded-lg bg-[#122A5C] px-2 py-2 text-xs font-semibold text-white"
      >
        <Calculator className="h-4 w-4" />
        Rechner
      </Link>
      <Link
        to="/angebot-anfordern"
        className="flex min-h-12 flex-col items-center justify-center gap-1 rounded-lg bg-[#E07000] px-2 py-2 text-xs font-semibold text-white"
      >
        <Send className="h-4 w-4" />
        Anfrage
      </Link>
      <a
        href="tel:+491608732681"
        className="flex min-h-12 flex-col items-center justify-center gap-1 rounded-lg border border-slate-200 bg-white px-2 py-2 text-xs font-semibold text-[#122A5C]"
      >
        <Phone className="h-4 w-4 text-[#E07000]" />
        Anrufen
      </a>
    </div>
  </div>
);

export const Layout = ({ children }) => {
  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <div className="pt-[72px] md:pt-[112px] lg:hidden">
        <MobileActionBar />
      </div>
      <main className="flex-grow lg:pt-[112px]">
        {children}
      </main>
      <Footer />
    </div>
  );
};
